import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../../firebase';
import { updateEmployee } from '../../../redux/slices/employeesSlice';
import { setUserProfileImage } from '../../../redux/slices/currentUserSlice';
import { uploadImageToStorage } from '../../../redux/actions/usersActions';
export const handleChoosePhotos = async (employee, dispatch) => {
  try {
    const employeeId = employee.id;

    // Create a file input element (similar to ConfigurePhotoStep)
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.hidden = true;

    // Create a promise to handle the file selection
    const filePromise = new Promise((resolve) => {
      input.onchange = (event) => {
        const file = event.target.files[0];
        if (file) {
          resolve(file);
        }
      };
    });

    // Trigger the file picker
    input.click();

    // Wait for file selection
    const file = await filePromise;
    const downloadURL = await uploadImageToStorage(file, employeeId);

    // Update Firestore
    const employeeRef = doc(db, 'employees', employeeId);
    await updateDoc(employeeRef, {
      profileImageUrl: downloadURL,
    });

    // Update Redux store
    dispatch(
      updateEmployee({
        id: employeeId,
        updatedEmployee: { profileImageUrl: downloadURL },
      })
    );

    // Update currentUser
    dispatch(setUserProfileImage({ profileImageUrl: downloadURL }));

    return downloadURL;
  } catch (error) {
    console.error('Error choosing photo:', error);
    throw error;
  }
};
